module.exports = __webpack_public_path__ + "static/img/frackB.d65a42d2.png";